import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { VisualGuideManagerService } from '../visual-guide-manager.service';

@Component({
    selector: 'lib-visual-guide-button',
    templateUrl: './visual-guide-button.component.html',
    styleUrls: ['./visual-guide-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VisualGuideButtonComponent {
  private readonly requestedGuide$ = new BehaviorSubject<string>('');
  @Input() disabled = false;
  @Output() readonly starting = new EventEmitter<void>();
  @Input() set guide(container: string) {
    this.requestedGuide$.next(container);
  }
  readonly isAvailable$ = combineLatest([
    this.manager.currentGuides$,
    this.requestedGuide$,
  ]).pipe(
    map(([guides, container]) =>
      guides.some((guide) => guide.container === container),
    ),
    distinctUntilChanged(),
  );

  constructor(private readonly manager: VisualGuideManagerService) {}

  startGuide(): void {
    if (this.disabled) return;
    this.starting.emit();
    this.manager.startGuide(this.requestedGuide$.value);
  }
}
